/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { useRef } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  List,
  ListItem,
  Typography,
  ListItemIcon,
  Divider,
  ClickAwayListener,
  Grow,
  Paper,
  Popper,
  MenuItem,
  MenuList,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import {NavLink, useLocation} from 'react-router-dom';
import ArrowRight from "@material-ui/icons/ArrowRight";

const useStyles = makeStyles((theme) => ({
  root: {},
  listItem: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  navLink: {
    '&:hover': {
      color: theme.palette.primary.dark,
    },
    fontFamily: 'Roboto',
    fontSize: 16,
    color: '#273A42',
    flex: '0 0 auto',
    // marginRight: theme.spacing(2),
    whiteSpace: 'nowrap',
    padding: '10px 20px 10px 20px',

    '&:after': {
      content: '""',
      display: 'block',
      height: 3,
      borderRadius: 3,
      // left: '50%',
      // marginLeft: -28,
      // bottom: -10,
      position: 'absolute',
      background: '#981B49',
      transition: 'width 0.3s ease 0s, left 0.3s ease 0s',
      width: 0,
      visibility: 'none',
      textAlign: 'center',
    },

    '&.menu-item-active-link:after': {
      width: '100%',
    },
    '&.menu-item-active-link': {
      color: '#981B49',
    },
  },
  listItemIcon: {
    minWidth: 'auto',
  },
  closeIcon: {
    justifyContent: 'flex-end',
    cursor: 'pointer',
  },
  menu: {
    display: 'flex',
  },
  menuItem: {
    marginRight: theme.spacing(8),
    '&:last-child': {
      marginRight: 0,
    },
  },
  menuGroupItem: {
    paddingTop: 0,
  },
  menuGroupTitle: {
    textTransform: 'uppercase',
  },
  divider: {
    width: '100%',
  },
  hoverStyle: {
    cursor: 'pointer',
  },
  subMenu: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: 'center',
    color: 'inherit',
    textDecoration: 'none',
    '&:visited': {
      color: 'inherit',
    },
  },
  listItemText: {
    fontFamily: 'Roboto',
    // fontSize: 17,
    color: '#273A42',
    flex: '0 0 auto',
    // marginRight: theme.spacing(2),
    whiteSpace: 'nowrap',
    // padding: '10px 20px 10px 20px',

    '&:after': {
      content: '""',
      display: 'block',
      height: 3,
      borderRadius: 3,
      left: '50%',
      marginLeft: -28,
      bottom: -10,
      position: 'absolute',
      background: '#981B49',
      transition: 'width 0.3s ease 0s, left 0.3s ease 0s',
      width: 0,
      visibility: 'none',
      textAlign: 'center',
    },

    '&:hover:after': {
      width: 56,
      right: '0',
    },

    '&.menu-item-active-link:after': {
      width: 56,
    },
  },
  listItemTextSub: {
    fontFamily: 'Roboto',
    color: '#273A42',
    flex: '0 0 auto',
    whiteSpace: 'nowrap',

    '&:after': {
      content: '""',
      display: 'block',
      height: 3,
      borderRadius: 3,
      left: '50%',
      marginLeft: -28,
      bottom: -10,
      position: 'absolute',
      background: '#981B49',
      transition: 'width 0.3s ease 0s, left 0.3s ease 0s',
      width: 0,
      visibility: 'none',
      textAlign: 'center',
    },

    '&:hover:after': {
      width: 56,
      right: '0',
    },

    '&.menu-item-active-link:after': {
      width: 56,
    },
  },
}));

const SidebarNav = (props) => {
  const { pages, onClose, className, ...rest } = props;
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [openSub, setOpenSub] = React.useState(false);
  const anchorRef = useRef();
  const subAnchorRef = useRef();

  const pagesList = Object.entries(pages).map(([key, value]) => {
    return value;
  });

  // Nested menu management
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
    // setOpenSub(false);
  };

  // Nested sub menu management
  const handleToggleSub = () => {
    setOpenSub((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if ((anchorRef.current && anchorRef.current.contains(event.target)) || (subAnchorRef.current && subAnchorRef.current.contains(event.target))) {
      return;
    }
    setOpenSub(false);
    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpenSub(false);
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpenSub(false);
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  const prevOpenSub = React.useRef(openSub);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
      prevOpen.current = open;
    }

    if (prevOpenSub.current === true && openSub === false) {
      subAnchorRef.current.focus();
      prevOpenSub.current = openSub;
    }
  }, [open, openSub]);

  const MenuGroup = (props) => {
    const { item } = props;
    return (
        <ListItem disableGutters className={classes.menuGroupItem}>
          {item.multiple ? (
            <>
              <div
                exact
                className={clsx(classes.navLink, 'submenu-item', classes.hoverStyle)}
                color='textPrimary'
                ref={item.multiple && anchorRef}
                id='composition-button'
                aria-controls={open ? 'composition-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup='true'
                onClick={handleToggle}
              >
                {item.title}
              </div>
              <Popper
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                placement='bottom-start'
                transition
                disablePortal
                style={{ zIndex: '1' }}
              >
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    style={{
                      transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom',
                    }}
                  >
                    <Paper>
                      <ClickAwayListener onClickAway={handleClose}>
                        <MenuList
                          autoFocusItem={open}
                          id='composition-menu'
                          aria-labelledby='composition-button'
                          onKeyDown={handleListKeyDown}
                        >
                          {item.subpages.map((subpage) => (
                              subpage.multiple ? (
                                  <MenuItem key={subpage.id}>
                                    <div
                                        color='textPrimary'
                                        className={clsx(classes.listItemText, 'menu-item')}
                                        ref={subpage.multiple && subAnchorRef}
                                        id='sub-composition-button'
                                        aria-controls={openSub ? 'composition-menu' : undefined}
                                        aria-expanded={openSub ? 'true' : undefined}
                                        aria-haspopup='true'
                                        onClick={handleToggleSub}
                                    >
                                          <span className={classes.subMenu} style={{color: "inherit", textDecoration: "none"}}>
                                            {subpage.title} <ArrowRight fontSize='large'/>
                                          </span>
                                      <Popper
                                          open={openSub}
                                          anchorEl={subAnchorRef.current}
                                          role={undefined}
                                          placement='right-start'
                                          transition
                                          style={{ zIndex: '9999' }}
                                          modifiers={
                                            {
                                              name: 'offset',
                                              options: {
                                                offset: [50, 0], // [horizontal, vertical] offsets
                                              },
                                            }
                                          }
                                      >
                                        {({ TransitionProps, placement }) => (
                                            <Grow
                                                {...TransitionProps}
                                                style={{
                                                  transformOrigin: placement === 'right-start' ? 'left top' : 'left bottom',
                                                }}
                                            >
                                              <Paper>
                                                <ClickAwayListener onClickAway={handleClose}>
                                                  <MenuList
                                                      autoFocusItem={openSub}
                                                      id='sub-composition-menu'
                                                      aria-labelledby='sub-composition-button'
                                                      onKeyDown={handleListKeyDown}
                                                  >
                                                    {subpage.subpages.map((subsubpage, i) => (
                                                        <MenuItem onClick={handleClose}>
                                                          <NavLink
                                                              exact
                                                              to={subsubpage.href}
                                                              color='textPrimary'
                                                              className={clsx(classes.listItemTextSub, 'menu-item')}
                                                              onClick={() => onClose()}
                                                          >
                                                            {subsubpage.title}
                                                          </NavLink>
                                                        </MenuItem>
                                                    ))}
                                                  </MenuList>
                                                </ClickAwayListener>
                                              </Paper>
                                            </Grow>
                                        )}
                                      </Popper>
                                    </div>
                                  </MenuItem>
                              ) : (
                                  <MenuItem onClick={handleClose}>
                                    <NavLink
                                        exact
                                        to={subpage.href}
                                        color='textPrimary'
                                        className={clsx(classes.listItemText, 'menu-item')}
                                        onClick={() => onClose()}
                                    >
                                      {subpage.title}
                                    </NavLink>
                                  </MenuItem>
                              )
                          ))}
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </>
          ) : (
            <NavLink
              to={item.href}
              color='textPrimary'
              exact
              activeClassName={'menu-item-active-link'}
              className={clsx(classes.navLink, 'submenu-item')}
              onClick={() => onClose()}
            >
              {item.title}
            </NavLink>
          )}
        </ListItem>
    );
  };

  const Pages = () => {
    return (
      <div className={classes.menu}>
        <div className={classes.menuItem}>
          <List disablePadding className={classes.navigationContainer}>
            {pagesList.map((item, index) => (
              <MenuGroup item={item} key={index} />
            ))}
          </List>
        </div>
      </div>
    );
  };

  return (
    <List {...rest} className={clsx(classes.root, className)}>
      <ListItem className={classes.closeIcon} onClick={() => onClose()}>
        <ListItemIcon className={classes.listItemIcon}>
          <CloseIcon fontSize='small' />
        </ListItemIcon>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Typography variant='h6' color='textPrimary' gutterBottom>
          Menu
        </Typography>
        <Pages />
      </ListItem>
      <ListItem className={classes.listItem}>
        <Divider className={classes.divider} />
      </ListItem>
    </List>
  );
};

SidebarNav.propTypes = {
  className: PropTypes.string,
  pages: PropTypes.object.isRequired,
  onClose: PropTypes.func,
};

export default SidebarNav;
